import React from 'react';

import { useGetUser } from '../data/useGetUser';
import type { GetUserQueryItem } from '../data/useGetUser';

export const withUser =
  <P extends React.PropsWithChildren<{ user: GetUserQueryItem | null }>>(
    Component: React.ComponentType<P>
  ): React.FC<Omit<P, 'user'> & { userId: string }> =>
  ({ userId, ...props }) => {
    const { data } = useGetUser({ variables: { cloudId: userId } });
    return data ? <Component user={data} {...(props as any)} /> : null;
  };
